const colors = {
  white: '#FFFFFF',
  black: '#000000',
  dark: '#2F3950',
  gray: '#77869E',
  gray2: '#A1A3A7',
  grayLight: '#F1F3F6',
  grayUltra: '#FAFAFA',
  primary: '#0057FF',
  green: '#02AD50',
  greenLight: '#DEFFE5',
  red: '#ED274B',
  redLight: '#FFC8D5',
  redUltra: '#FFEFE9',
  yellow: '#FFB800',
  riskGreen: '#00BF59',
  riskOrange: '#ff9900',
  riskRed: '#FF6D5C',
};

export default colors;
